"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const create = config => {
  const {
    root,
    imageResizeRoot = root
  } = config;
  const resize = (url = {}, {
    webp,
    mediaReady = true,
    ...options
  } = {}) => {
    const imagePath = url && url.s3_web_path || url && url.url || url;
    const webpFormat = webp ? {
      format: 'webp'
    } : {};
    if (!imagePath || !mediaReady) return '';
    const defaults = {
      fit: 'inside',
      quality: 60,
      withoutEnlargement: true,
      ...webpFormat,
      ...options
    };
    const params = Object.keys(defaults).map(key => `${key}_${defaults[key]}`).join(',');
    return `${imageResizeRoot}/${params}/${imagePath}`;
  };
  return {
    resize
  };
};
exports.create = create;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(create, "create", "/Users/jake.clayton/frontend/ls-common-client/src/imageResizer.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();